import moment from "moment";

import { Tooltip } from "@samacare/design";

export const GridCellDate: React.FC<{ value: string }> = ({ value }) => (
  <Tooltip title={moment(value).format("LLLL")}>
    <span>{moment(value).format("L")}</span>
  </Tooltip>
);
